import { render, staticRenderFns } from "./NoService.vue?vue&type=template&id=466b755f&scoped=true&"
import script from "./NoService.vue?vue&type=script&lang=js&"
export * from "./NoService.vue?vue&type=script&lang=js&"
import style0 from "./NoService.vue?vue&type=style&index=0&id=466b755f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466b755f",
  null
  
)

export default component.exports